import React from 'react';

import styles from './Loader.scss';


const Loader = ({ size }) => {
  const value = size || 20;

  return (
    <div className={ styles.wrapper }>
      <div className={ [styles.wrapper__loader, styles.loader].join(' ') }>
        <svg className={ [styles.loader__svg, styles.svg].join(' ') } viewBox="25 25 50 50">
          <circle
            className={ styles.svg__circle }
            cx="50"
            cy="50"
            r={ value }
            fill="none"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
        </svg>
      </div>
    </div>
  );
};

export default Loader;
